import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "billing-banner__content" }
const _hoisted_2 = { class: "billing-banner__message" }

import { computed } from "vue";
import { useStore } from "vuex";
import { Icon } from "@iconify/vue";
import { CLEAR_PERSISTENT_BANNER } from "@/store/mutation-types";


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingBanner',
  setup(__props) {

const store = useStore();

const banner = computed(() => store.getters.persistentBanner);

const bannerIcon = computed(() => {
  const t = banner.value?.type;
  if (t === "error") return "mdi:alert-circle-outline";
  if (t === "warning") return "mdi:alert-outline";
  return "mdi:information-outline";
});

const dismiss = () => {
  store.commit(CLEAR_PERSISTENT_BANNER);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "banner" }, {
    default: _withCtx(() => [
      (banner.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["billing-banner", `billing-banner--${banner.value.type}`]),
            role: "alert"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(Icon), {
                icon: bannerIcon.value,
                class: "billing-banner__icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(banner.value.message), 1)
            ]),
            (banner.value.dismissible)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "billing-banner__dismiss",
                  "aria-label": "Dismiss",
                  onClick: dismiss
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:close" })
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})